import React from 'react';
import PlaceAutocomplete from './PlaceAutocomplete';
import styled from 'styled-components';
import { SvgIcons, Input } from 'synapsefi-dev-ui';
import { ARSENIC } from '../../../../constants/colors';

const LoaderWrapper = styled.div`
`;

const DropdownContainer = styled.div`
  position: absolute;
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  z-index: 2;
  margin-top: -20px;
  width: 100%;
`;

const AutoCompleteWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SuggestionList = styled.div`
  padding: 8px;
`

class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { address: '' };
  }

  handleChange = address => {
    this.setState({ address });
    this.props.handleUpdate(null, address, this.props.fieldName);
  };

  handleSelect = (address, id, obj) => {
    this.handleChange(address);
  };

  render() {
    const { className, handleUpdate, label, address } = this.props;

    return (
      <PlaceAutocomplete
        onChange={this.handleChange}
        value={address}
        onSelect={this.handleSelect}
        searchOptions={{ types: ['address'] }}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <AutoCompleteWrapper
            className={className}
          >
            <Input
              {...getInputProps({
                placeholder: '1234 Example St.',
              })}
              label={label}
            />

            <DropdownContainer>
              {loading && <LoaderWrapper isLoading={loading}>
                <SvgIcons.synapse_circle_logo color={ARSENIC} size={'8px'} rotate_ccw_normal/>
              </LoaderWrapper>}
              {suggestions.map(suggestion => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <SuggestionList
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </SuggestionList>
                );
              })}
            </DropdownContainer>
          </AutoCompleteWrapper>
        )}
      </PlaceAutocomplete>
    );
  }
}

export default LocationSearchInput;